import { render } from "./OurBlog.vue?vue&type=template&id=6f9bd945&scoped=true&ts=true"
import script from "./OurBlog.vue?vue&type=script&lang=ts"
export * from "./OurBlog.vue?vue&type=script&lang=ts"

import "./OurBlog.vue?vue&type=style&index=0&id=6f9bd945&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f9bd945"]])

export default __exports__